import {constructionEndDateOptions} from "../../real_estate/constants/construction_end_date_options";

export function stringifyConstructionEndDate(constructionEndDate: number[]): string {
    if (!constructionEndDate?.length || constructionEndDate?.length === 0) {
        return "";
    }

    const labels = constructionEndDate.map((months) => {
        const option = constructionEndDateOptions.find((option) => option.value === months);

        return option?.label;
    });

    return labels.filter(Boolean).join(", ");
}
